$(document).ready(function () {
  // get the accordion title c-outage-page__accordion-title
  $(".c-outage-page__accordion-title").click(function () {
    //slidetoggle the class within c-outage-page__accordion-content
    $(this).next(".c-outage-page__accordion-content").slideToggle(400);
    //add open class to c-outage-page__accordion-arrow
    $(this)
      .find(".c-outage-page__accordion-arrow")
      .toggleClass("c-outage-page__accordion-arrow--open");
  });
});
